import store from '@Store';
import React from 'react';
import InnerHTML from '@Components/InnerHTML';
import { Button, ButtonWithIcon } from '@els/els-react--button';
import { open as openSupplierInfoDialog } from '@Containers/RcsSupplierInfo/RcsSupplierInfoDialog/RcsSupplierInfoDialogAction';
import { addUrlProtocol } from '@Utils/String';
import Catalyst from '@Services/Catalyst';

// eslint-disable-next-line import/prefer-default-export
export function SubstanceCommercialSupplierInformationCellSupplier(props) {
  const {
    supplierUrl,
    supplierName,
    originalSupplierName,
    rcProductName,
    suppliersProductNumber,
    rcSupplierId,
    databaseId,
    supplierLocation,
    casRegistryNumbers,
  } = props;

  const onSupplierNameClick = () => {
    const url = addUrlProtocol(supplierUrl);
    // AA
    Catalyst.trackLinkOut(
      {
        id: casRegistryNumbers, // CAS number
        id2: suppliersProductNumber, // Supplier Product Number
        id3: rcProductName, // Product
        linkOut: 'supplier-info:supplier-name',
      },
      {
        location: url, // Full URL
        name: supplierName,
        type: 'Supplier Information',
        destination: supplierName,
      }
    );
    window.open(addUrlProtocol(supplierUrl), '_blank');
  };

  return (
    <td className="column-supplier">
      <div className="supplier-name-row">
        {supplierUrl && supplierName && (
          <Button
            type="link"
            className="u-els-color-link-inline supplier-name-link e2e-commercial-supplier-name"
            onClick={onSupplierNameClick}>
            <InnerHTML tag="span" html={supplierName} />
          </Button>
        )}
        {supplierName && !supplierUrl && <InnerHTML tag="span" className="supplierName" html={supplierName} />}
        <ButtonWithIcon
          sprite="InformationOutlineCircle"
          type="link"
          iconOnly
          linkIconSize="xs"
          className="u-els-margin-left-1x e2e-commercial-supplier-info"
          onClick={() => {
            store.dispatch(
              openSupplierInfoDialog(rcSupplierId, databaseId, {
                handleWebAddressClick: onSupplierNameClick,
                disableAATracking: true,
              })
            );
          }}>
          Supplier info
        </ButtonWithIcon>
      </div>
      {originalSupplierName && <InnerHTML tag="span" className="originalSupplierName" html={`<br/>${originalSupplierName}`} />}
      {supplierLocation && <InnerHTML tag="div" className="supplierLocation" html={supplierLocation} />}
    </td>
  );
}
